export const BASE_URL = 'https://876d-1-186-228-46.in.ngrok.io';
export const SPOTDRAFT_URL = 'https://app.qa.dev.spotdraft.com/auth/embed-contract';
export const GET_STREAM_TOKEN = '5g9npp3h462d';
export const GRAMMARLY_CLIENT_ID = 'client_2TEoV71FX98fwba1gAm4RM';
export const CREATE_PROJECT_BASE_URL = 'https://versions.peppercontent.dev';
export const REACT_APP_LOOM_API_KEY = '05d592cf-ed8b-4db1-b070-249d24f6c9a6';
export const REACT_APP_UNSPLASH_KEY = '-J2WKws-0lUDfWyqcpC5El8sXM0-agvibTqrlDfteto';
//# sourceMappingURL=config.js.map